<template>
    <div>
        <b-sidebar aria-labelledby="sidebar-no-header-title" no-header id="add_fixed_assets" backdrop style="direction:ltr" width="50rem" right :title="`اضافة اصول ثابتة`" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="white-space:nowrap;padding-inline:1px;width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                    <span>{{ pagetitle }}</span>
                    </div>
                    <div @click="hide" id="closeaddpayment" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm closethis">
                    <span>{{$parent.lang.close}}</span>
                </div>
                </div>
                <v-divider></v-divider>
                <v-row :style="`direction:`+$parent.lang.dir" class="pa-2 m-2">
                    <v-col cols="12" md="5" sm="12">
                        <label>{{$parent.lang.fixed_assets_namear}}</label>
                        <b-form-input class="inborder"
                            :label="$parent.lang.namear"
                            v-model="namear" 
                            :rules="fieldRules"
                        >{{ namear }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="5" sm="12">
                        <label>{{$parent.lang.fixed_assets_nameen}}</label>
                        <b-form-input class="inborder"
                            :label="$parent.lang.nameen"
                            v-model="nameen" 
                            :rules="fieldRules"
                        >{{ nameen }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{ $parent.lang.purchase_price }}</label>
                        <b-form-input class="inborder"
                            v-model="pprice" 
                            type="number"
                        >{{ pprice }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{$parent.lang.qtty}}</label>
                        <b-form-input class="inborder"
                            v-model="qtty" 
                            type="number"
                        >{{ qtty }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <label>{{$parent.lang.depreciation_rate}}</label>
                        <b-form-input class="inborder"
                            v-model="dep_percentage" 
                            type="number"
                        >{{ dep_percentage }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{ $parent.lang.purchase_date }}</label>
                        <b-form-input class="inborder"
                            v-model="purchase_date" 
                            type="date"
                        >{{ purchase_date }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <label>{{ $parent.lang.department }}</label>
                        <b-input-group>
                        <b-form-select class="selborder"
                            v-model="groupid"
                            :options="groups"
                        ></b-form-select>
                            <b-input-group-addon style="color:#fff;margin-inline:-20px;margin-top:5px;">
                                <i class="fas fa-arrow-down"></i>
                            </b-input-group-addon>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <label>{{ $parent.lang.depreciation_account }}</label>
                        <b-input-group>
                        <b-form-select class="selborder"
                            v-model="dep_group"
                            :options="depGroups"
                        ></b-form-select>
                            <b-input-group-addon style="color:#fff;margin-inline:-20px;margin-top:5px;">
                                <i class="fas fa-arrow-down"></i>
                            </b-input-group-addon>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <label>{{ $parent.lang.depreciation_period }}</label>
                        <b-input-group>
                        <b-form-select class="selborder"
                            v-model="dep_period"
                            :options="depPeriods"
                        ></b-form-select>
                            <b-input-group-addon style="color:#fff;margin-inline:-20px;margin-top:5px;">
                                <i class="fas fa-arrow-down"></i>
                            </b-input-group-addon>
                        </b-input-group>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <label>{{ $parent.lang.payment_type }}</label>
                        <b-input-group>
                        <b-form-select class="selborder"
                            v-model="pay_type"
                            :options="payTypes"
                        ></b-form-select>
                            <b-input-group-addon style="color:#fff;margin-inline:-20px;margin-top:5px;">
                                <i class="fas fa-arrow-down"></i>
                            </b-input-group-addon>
                        </b-input-group>
                    </v-col>
                </v-row>
            </template>
            <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                        <b-button type="button" @click="addPaytype();" variant="success" class="ma-2" style="width:100px;">حفظ</b-button>
                    </div>
            </template>
        </b-sidebar>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';
export default {
    data() {
        return {
            depAccount: 0,
            id: '', 
            namear: '', 
            nameen: '', 
            groupid: 1, 
            dep_period: 1, 
            dep_group:0,
            pprice: '', 
            purchase_date: '', 
            dep_percentage: '',
            pay_type: 1,
            qtty: 1,
            groups: [],
            fieldRules: [],
            pagetitle: '',
            dep_groups: [],
            payTypes: [],
        }
    },
    created() {
        this.getGroups();
        this.getPyamentType();
    },
    computed: {
        depGroups: function() {
            let t = [{text: this.$parent.lang.chose_from_list, value: 0}];
            for(let i =0; i< this.dep_groups.length; i++){
                t.push({text: this.dep_groups[i][`name${this.$parent.lang.langname}`], value: this.dep_groups[i].classid});
            }
            return t;
        },
        depPeriods: function(){
            return [
                {text: this.$parent.lang.monthly, value: 1},
                {text: this.$parent.lang.quarter, value: 2},
                {text: this.$parent.lang.semiannually, value: 3},
                {text: this.$parent.lang.annually, value: 4},
            ]
        }
    },
    methods: {
        getPyamentType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPayTypes');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.payTypeOp = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.payTypes.push({
                        text: this.$parent.lang.langname == 'ar' ? res.results.data[i].type_name : res.results.data[i].type_name_en,
                        value: res.results.data[i].id
                    })
                }
                // this.paytypeOp = t;

                this.pay_type = res.results.data[0].id;
            })
        },
        restAll(){
            this.id = '';
            this.namear = '';
            this.nameen = '';
            this.groupid = 1;
            this.pprice = '';
            this.dep_group = 0;
            this.dep_period = 1;
            this.pay_type = 1;
            this.qtty = 1;
            this.purchase_date = '';
            this.dep_percentage = '';
            this.pagetitle = this.$parent.lang.add_fixed_assets;
        },
        restall(){
            this.id = '';
            this.namear = '';
            this.nameen = '';
            this.groupid = 1;
            this.dep_group = 0;
            this.dep_period = 1;
            this.pay_type = 1;
            this.pprice = '';
            this.qtty = 1;
            this.purchase_date = '';
            this.dep_percentage = '';
            this.pagetitle = this.$parent.lang.add_fixed_assets;
        },
        fillit(item){
            this.id = item.id;
            this.namear = item.namear;
            this.nameen = item.nameen;
            this.groupid = item.groupid;
            this.dep_period = item.dep_period;
            this.pay_type = item.item;
            this.dep_group = item.dep_group;
            this.pprice = item.pprice;
            this.qtty = item.qtty;
            this.purchase_date = item.purchase_date;
            this.dep_percentage = item.dep_percentage;
        },
        getGroups(){
            const post = new FormData();
            post.append("type","getAssetsGroups")
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append("data[lang]",this.$parent.lang.langname);
    
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.groups = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.groups.push({
                        text: res.results.data[i].namear,
                        value: res.results.data[i].classid,
                    })
                }
                this.dep_groups = res.results.dep_groups;
            })
        },
        
        addPaytype(){
            let vald = true;
            let mess = '';
            if(this.namear == ''){
                vald = false;
                mess = this.$parent.lang.plase_add_assets_ar_name;
            }
            if(this.namene == '' && vald){
                vald = false;
                mess = this.$parent.lang.plase_add_assets_en_name;
            }
            if(this.pprice == '' && vald){
                vald = false;
                mess = this.$parent.lang.please_add_purchase_price;
            }
            if(this.purchase_date == '' && vald){
                vald = false;
                mess = this.$parent.lang.please_add_purchase_date;
            }
            if(this.dep_percentage == '' && vald){
                vald = false;
                mess = this.$parent.lang.please_add_depricated_ratio;
            }
            if(this.qtty == '' && vald){
                vald = false;
                mess = this.$parent.lang.please_add_qtty;
            }

            if(vald == false){
                this.$snotify.error(mess, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
            const post = new FormData();
            post.append('type',"doaddFixedAssets");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[id]',this.id);
            post.append('data[namear]',this.namear);
            post.append('data[nameen]',this.nameen);
            post.append('data[groupid]',this.groupid);
            post.append('data[dep_group]',this.dep_group);
            post.append('data[pprice]',this.pprice);
            post.append('data[qtty]',this.qtty);
            post.append('data[purchase_date]',this.purchase_date);
            post.append('data[dep_percentage]',this.dep_percentage);
            post.append('data[dep_period]',this.dep_period);
            post.append('data[pay_type]',this.pay_type);
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                const res = response.data;
                // // console.log(res);
                if(typeof res.results.data !== 'undefined')
                {
                    let message = res.results.data;
                    this.$snotify.error(message, this.$parent.lang.alert, {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.$parent.lang.close, 
                                action: (toast) => {
                                    this.$snotify.remove(toast.id); 
                                } 
                            },
                        ]
                    });
                    document.getElementById('closeaddpayment').click();
                    this.$parent.getFixedAsstes();
                }
            })
        }
    },
}
</script>